window.addEventListener("load", (event) => {  
class ProductBundle extends HTMLElement {
  static selectedVariants = {};
  constructor() {
    super();
    this.addEventListener("click", this.productclick);
    this.addEventListener("change", this.lenghtupdate);
    this.addEventListener("input", ProductBundle.ClickEvent);
    this.addEventListener("input", this.Remove);
  } 
  Remove(){
    const inputField = this.querySelector(".monogram-letters");
    let inputValue = inputField.value;
    console.log (inputValue)
    if (inputField.value < 0 ){
      inputField.value = '';
      inputField.blur();
    }
    if (inputField.value.trim() == "") {
     const dataGroup = this.getAttribute("data-group");  
       delete ProductBundle.selectedVariants[dataGroup];
     this.classList.remove("selected");
      inputField.blur();
       ProductBundle.addorremoveadditionalproduct();
    ProductBundle.formupdate();    
    ProductBundle.priceupdate();  
    ProductBundle.LastStepProductAppend();   
  }
  }
static ClickEvent(){
  setTimeout(function(){
ProductBundle.priceupdate();
    ProductBundle.ShowError();
}, 500);
}
 static ShowError(){
 let shouldReturn = false;
 const hasRope = "Rope" in ProductBundle.selectedVariants;
  const hasGalvanizedChain = "galvanized-chain" in ProductBundle.selectedVariants;
  const hasStainlessSteel = "stainless-steel" in ProductBundle.selectedVariants;
  const hasSwivels = "Swivels" in ProductBundle.selectedVariants;
 
  if (!hasRope || (hasGalvanizedChain && hasStainlessSteel)) {
  let error = "Error: Missing Products  - ";

  if (!hasRope) {
    error += "Rope ";
  }
  /*if (!hasGalvanizedChain || !hasStainlessSteel) {
    error += "Chain ";
  }*/
    if (!hasGalvanizedChain && !hasStainlessSteel) {
  error += " Chain ";
}
 if (!hasSwivels) {
    error += "Swivels ";
  }
 
document.querySelector(".error").textContent = error;
document.querySelector('.mydivrvrnt').style.pointerEvents = 'none';
    shouldReturn = true;
}else {
    
  document.querySelector(".error").textContent = '';
    document.querySelector('.mydivrvrnt').style.pointerEvents = 'auto';
  }
   if (shouldReturn) {   
    return;
  }
   const size = Object.keys(ProductBundle.selectedVariants).length;
console.log(size);
if(size == 1 &&  hasRope ){
  let error = "Error: Missing Products  - Chain";
  document.querySelector(".error").textContent = error;
document.querySelector('.mydivrvrnt').style.pointerEvents = 'none';
 shouldReturn = true;
}
    if (shouldReturn) {   
    return;
  }
   if(hasGalvanizedChain || hasStainlessSteel){
  let availableVariant = hasGalvanizedChain
  ? ProductBundle.selectedVariants['galvanized-chain']
  : hasStainlessSteel
  ? ProductBundle.selectedVariants['stainless-steel']
  : null;
let divElement = document.querySelector(`[variant-id="${availableVariant}"]`);
let inputField = divElement.querySelector('input[name="properties[length]"]');
if (inputField && inputField.value.trim() !== '') {
 document.querySelector(".error").textContent = '';
    document.querySelector('.mydivrvrnt').style.pointerEvents = 'auto';
} else {
 let error = "Error: Please enter length";
  document.querySelector(".error").textContent = error;
document.querySelector('.mydivrvrnt').style.pointerEvents = 'none';
shouldReturn = true;
}
   }
     if (shouldReturn) {   
    return;
  }

  if(hasRope){
let availableVariant = hasRope
  ? ProductBundle.selectedVariants['Rope']
  : null;
  if(availableVariant == 44236695208186){}else{
let divElement = document.querySelector(`[variant-id="${availableVariant}"]`);
let inputField = divElement.querySelector('input[name="properties[length]"]');
if (inputField && inputField.value.trim() !== '') {
 document.querySelector(".error").textContent = '';
    document.querySelector('.mydivrvrnt').style.pointerEvents = 'auto';
} else {
  shouldReturn = true;
 let error = "Error: Please enter length";
  document.querySelector(".error").textContent = error;
document.querySelector('.mydivrvrnt').style.pointerEvents = 'none';
}
  }
   }
if(!hasSwivels){
 let error = "Error: Missing Products  - Swivels";
  document.querySelector(".error").textContent = error;
document.querySelector('.mydivrvrnt').style.pointerEvents = 'none';
   console.log("no swills")

 }
 if(hasSwivels){
 document.querySelector(".error").textContent = '';
    document.querySelector('.mydivrvrnt').style.pointerEvents = 'auto';
   console.log(" swills")
 }
     if (shouldReturn) {   
    return;
  }

 } 
  
static addorremoveadditionalproduct() {
console.log(ProductBundle.selectedVariants)
  const hasSwivels = "swivels" in ProductBundle.selectedVariants;


  const hasRope = "Rope" in ProductBundle.selectedVariants;
  const hasGalvanizedChain = "galvanized-chain" in ProductBundle.selectedVariants;
  const hasStainlessSteel = "stainless-steel" in ProductBundle.selectedVariants;
  const hasHandcraftSpliceend = "HandcraftSpliceendForrope" in ProductBundle.selectedVariants; 
  const hasRopen = "Rope" in ProductBundle.selectedVariants;
  if(hasRope && ( hasGalvanizedChain || hasStainlessSteel ) ){
      const variantId = document.querySelector("[product-sku='4564']").getAttribute("variant-id");
  const variant = document.querySelector("[product-sku='4564']");
       variant.classList.add('selected');
  let Addclass = document.querySelector(".product-with-img");
  Addclass.classList.add('show')
  ProductBundle.selectedVariants["HandcraftSpliceendForrope"] = variantId;
   }  
  if (hasGalvanizedChain || hasStainlessSteel) {    
 if (hasGalvanizedChain) {
  const variantId = document.querySelector("[product-sku='4692']").getAttribute("variant-id");
  const variant = document.querySelector("[product-sku='4692']");
  variant.classList.add('selected');
  let Addclass = document.querySelector(".product-with-img");
  Addclass.classList.add('show')
  ProductBundle.selectedVariants["HandcraftSpliceend"] = variantId;
}    
    if(hasStainlessSteel  ){
    const variantId = document.querySelector("[product-sku='4691']").getAttribute("variant-id");
  const variant = document.querySelector("[product-sku='4691']");
  variant.classList.add('selected');
  let Addclass = document.querySelector(".product-with-img");
  Addclass.classList.add('show')
  ProductBundle.selectedVariants["HandcraftSpliceend"] = variantId;
    } 
  } else if (hasHandcraftSpliceend && !hasRopen) {
    let Addclass = document.querySelector(".product-with-img");
    Addclass.classList.remove('show')
   const variant = document.querySelector("[data-group='HandcraftSpliceend']");
    variant.classList.remove('selected');
    delete ProductBundle.selectedVariants["HandcraftSpliceendForrope"];  
  }
 if(hasRope && (ProductBundle.selectedVariants["Rope"] == 44236695208186)){  
    delete ProductBundle.selectedVariants["HandcraftSpliceendForrope"];   
  }
  if(!hasRope ){  
    delete ProductBundle.selectedVariants["HandcraftSpliceendForrope"];   
  }
if (!(hasGalvanizedChain || hasStainlessSteel)) {
 // console.log("no chain")
delete ProductBundle.selectedVariants["HandcraftSpliceend"];
  delete ProductBundle.selectedVariants["HandcraftSpliceendForrope"];
} 

    let enter = false;
   for (let [key, value] of Object.entries(ProductBundle.selectedVariants)) {
let productCardBundle = document.querySelector(`[variant-id="${value}"]`);      
     let sku = productCardBundle.getAttribute('product-sku');  
     if (sku === '4489' || sku === '4492') {
     
       let ShackleSkuAdd =   document.querySelector("[product-sku='3676']");
       let variantid = ShackleSkuAdd.getAttribute("variant-id");    
       let datagroup = ShackleSkuAdd.getAttribute("data-group"); 
       ProductBundle.selectedVariants["Shackle"] = variantid;      
       document.querySelectorAll(`[data-group="${datagroup}"]`).forEach((el) => {
      if (el.getAttribute('variant-id') !== variantid) {
        el.classList.add('hide');
         el.classList.remove('selected');
      }else{
        el.classList.remove('hide');
        el.classList.add('selected');
      }  
    });
       let enter = true;
       break;
  } else if (sku === '4490' || sku === '4493') {
     
        let ShackleSkuAdd =   document.querySelector("[product-sku='4508']");
    let variantid = ShackleSkuAdd.getAttribute("variant-id");
     let datagroup = ShackleSkuAdd.getAttribute("data-group"); 
     ShackleSkuAdd.classList.add('selected')
       
      ProductBundle.selectedVariants["Shackle"] = variantid;
        document.querySelectorAll(`[data-group="${datagroup}"]`).forEach((el) => {
      if (el.getAttribute('variant-id') !== variantid) {
      el.classList.add('hide');
         el.classList.remove('selected');
      }else{
          el.classList.remove('hide');
        el.classList.add('selected');
      }
    });
        let enter = true;
       break;
  } else if (sku === '4491' || sku === '4494') {
    console.log("third skeu")
      let ShackleSkuAdd =   document.querySelector("[product-sku='4509']");
    let variantid = ShackleSkuAdd.getAttribute("variant-id");
     let datagroup = ShackleSkuAdd.getAttribute("data-group"); 

      ProductBundle.selectedVariants["Shackle"] = variantid;
        document.querySelectorAll(`[data-group="${datagroup}"]`).forEach((el) => {
      if (el.getAttribute('variant-id') !== variantid) {
        el.classList.add('hide');
         el.classList.remove('selected');
      }else{
         el.classList.remove('hide');
        el.classList.add('selected');
      }
    });  
    break;
  } else { 
 delete ProductBundle.selectedVariants["Shackle"];
          document.querySelectorAll('[data-group="Shackle"]').forEach((el) => {
         el.classList.remove('selected'); 
         el.classList.remove('hide'); 
    }); 
  }
       };
 const productCards = document.querySelectorAll('.product-card');
productCards.forEach((card) => {
  if (card.classList.contains('selected')) {
    card.classList.remove('selected');
  }
});

     for (let [key, value] of Object.entries(ProductBundle.selectedVariants)) {
let productCardBundle = document.querySelector(`[variant-id="${value}"]`);  
productCardBundle.classList.add('selected')
         };
     let splice = false;
   const hasHandcraftSpliceendend = "HandcraftSpliceendForrope" in ProductBundle.selectedVariants; 

   
    if(hasHandcraftSpliceendend){     
splice = true;
  let show =  document.querySelector(`[variant-id="44214635036922"]`);
    show.classList.add('selected'); 
    show.classList.remove('hide'); 
     
   let hideone = document.querySelector(`[variant-id="44240223371514"]`);
    hideone.classList.add('hide'); 
      hideone.classList.remove('selected');
       
   let hidetwo = document.querySelector(`[variant-id="44240223338746"]`);
    hidetwo.classList.add('hide'); 
       hidetwo.classList.remove('selected');
  }
  if(!splice){
       let Addclass = document.querySelector(".product-with-img");
    Addclass.classList.remove('show')
  }
 ProductBundle.ShowError();
}

static LastStepProductAppend(){
let ProducList = document.querySelector('.product-block.product-with-accordian .product-list-acc');
ProducList.innerHTML = ''; 
  if (ProductBundle.selectedVariants.Shackle)  { 
    let productCardBundle = document.querySelector(`[variant-id="${ProductBundle.selectedVariants.Shackle}"]`); 
    let clonedProductCardBundle = productCardBundle.cloneNode(true);
  let ProducList = document.querySelector('.product-block.product-with-accordian .product-list-acc');  
    ProducList.appendChild(clonedProductCardBundle);
    document.body.classList.add('mynewbodyclass');
}

if (ProductBundle.selectedVariants.HandcraftSpliceend)  {
  
   let productCardBundle = document.querySelector(`[variant-id="${ProductBundle.selectedVariants.HandcraftSpliceend}"]`);
  
  let clonedProductCardBundle = productCardBundle.cloneNode(true);
  clonedProductCardBundle.classList.remove('hide')
  clonedProductCardBundle.classList.add('selected')
   let ProducList = document.querySelector('.product-block.product-with-accordian .product-list-acc');  
    ProducList.appendChild(clonedProductCardBundle);
  document.body.classList.add('mynewbodyclass');
}  
  /*if (ProductBundle.selectedVariants.HandcraftSpliceendForrope)  {
   let productCardBundle = document.querySelector(`[variant-id="${ProductBundle.selectedVariants.HandcraftSpliceendForrope}"]`);
  let clonedProductCardBundle = productCardBundle.cloneNode(true);
   let ProducList = document.querySelector('.product-block.product-with-accordian .product-list-acc');  
    ProducList.appendChild(clonedProductCardBundle);
}*/

 /*document.querySelectorAll('[data-group="HandcraftSpliceend"]').forEach((el) => {
el.classList.remove('hide');
   }); */
  const size = Object.keys(ProductBundle.selectedVariants).length;
  if(size < 1 ){
    document.body.classList.remove('mynewbodyclass');
  }
  const hasRope = "Rope" in ProductBundle.selectedVariants;
  if(hasRope &&  size == 1){  
     document.body.classList.remove('mynewbodyclass');
  }
}
  
static priceupdate(){
   const cartData = BundleProduct.getCartData(); 
console.log(cartData)
console.log("priceupdate cart data")
 var mybundlet = 0 ;
  var currencySymbol ;
  var mymulitply;
   cartData.forEach((product, index) => {
let productCardBundle = document.querySelector(`[variant-id="${product.bundleId}"]`); 
     let datagroup = productCardBundle.getAttribute("data-group");
     if(datagroup == 'stainless-steel'  || datagroup == 'galvanized-chain' || datagroup == 'Rope' ){
      
    let input =  productCardBundle.querySelector('.monogram-letters');
       if(input){
     mymulitply = input.value;
       console.log(mymulitply)
     }
     }
      let price = productCardBundle.querySelector('.product-price-bndle').textContent;     
       let priceWithoutCurrency = Number(price.replace(/[^0-9.-]+/g,""));

       //currencySymbol = price.match(/^[^\d]+/)[0]; 
      currencySymbol = price.match(/^\D+/);
      if(mymulitply){
        console.log(priceWithoutCurrency)
     priceWithoutCurrency =  priceWithoutCurrency * mymulitply;
        console.log(priceWithoutCurrency)
         console.log("price withoutcurrency")
         mymulitply = null;
      }
     if(datagroup == 'Shackle'){
       priceWithoutCurrency = priceWithoutCurrency * 2;
     }
     if(datagroup == 'swivels'){
       priceWithoutCurrency = priceWithoutCurrency * 2;
     }
      mybundlet = mybundlet + priceWithoutCurrency;
     //priceWithoutCurrency = priceWithoutCurrency / 100;     
      });
  let total = mybundlet.toFixed(2);
  const input45 = document.getElementById('bcontact-Total-239730');
       if(typeof currencySymbol == "undefined"){
         document.querySelector('.price-text').textContent = total;
      input45.value = total;   
     }else {
         document.querySelector('.price-text').textContent = currencySymbol +total;
         input45.value =  currencySymbol +total;
     }  
     input45.dispatchEvent(new Event('input', { bubbles: true }));  
}
 static formupdate(){
   const inputElementsempty = document.querySelectorAll('.hideinput input');
inputElementsempty.forEach(input => {
  if (input.tagName === 'INPUT') {
    input.value = '';
  }
});
   const inputElements = document.querySelectorAll('.hideinput')
       const cartData = BundleProduct.getCartData();
console.log(cartData)  
console.log("cart data") 
   const datagroupsToUpdate =[];   
   cartData.forEach((product, index) => {
let productCardBundle = document.querySelector(`[variant-id="${product.bundleId}"]`);
console.log(productCardBundle)
     const lengthInput = productCardBundle.querySelector('input[name="properties[length]"]');
  const lengthValue = lengthInput ? lengthInput.value : '';     
     let productitle = productCardBundle.querySelector('.product-card__title a').textContent;
let datagroup = productCardBundle.getAttribute("data-group");   
     datagroupsToUpdate.push(datagroup);

  /*   if(product.bundleId == 44214635036922 ){
       let divElement = document.querySelector('.ropesplide');     
 let inputElement = divElement.querySelector('input');
     inputElement.value = productitle;
     if(lengthValue){
     inputElement.value += ",  Length: " + lengthValue;
     } 
     }else{
console.log(datagroup)
let divElement = document.querySelector('.' + datagroup);    
console.log(divElement) 
 let inputElement = divElement.querySelector('input');
     inputElement.value = productitle;
     if(lengthValue){
     inputElement.value += ",  Length: " + lengthValue;
     }  
     }
*/if (product.bundleId == 44214635036922) {
    let divElements = document.querySelectorAll('.ropesplide');
    
    divElements.forEach(divElement => {
        let inputElement = divElement.querySelector('input');
        if (inputElement) {
            inputElement.value = productitle;
            if (lengthValue) {
                inputElement.value += ",  Length: " + lengthValue;
            }
        }
    });
} else {
    console.log(datagroup);
    let divElements = document.querySelectorAll('.' + datagroup);
    console.log(divElements);

    divElements.forEach(divElement => {
        let inputElement = divElement.querySelector('input');
        if (inputElement) {
            inputElement.value = productitle;
            if (lengthValue) {
                inputElement.value += ",  Length: " + lengthValue;
            }
        }
    });
}
     });
   inputElementsempty.forEach(input => {
  input.dispatchEvent(new Event('input'));
});
   
 }
  lenghtupdate(event){   
       ProductBundle.formupdate();
        ProductBundle.priceupdate();
  }  
  productclick(event) {
  event.preventDefault();
    if (event.target.tagName.toLowerCase() === "input" && event.target.classList.contains("monogram-letters")) {   
    if( this.classList.contains("selected")){
      return;
    }
  }    
  const variantId = this.getAttribute("variant-id");
  const dataGroup = this.getAttribute("data-group");    
  const inputField = this.querySelector(".monogram-letters");
    if(inputField){
       inputField.focus();
    } 
if (variantId && (dataGroup === "stainless-steel" || dataGroup === "galvanized-chain")) {
  const otherDataGroup = dataGroup === "stainless-steel" ? "galvanized-chain" : "stainless-steel";
  const otherDataGroupSelected = Boolean(ProductBundle.selectedVariants[otherDataGroup]);
  if (otherDataGroupSelected) {
    delete ProductBundle.selectedVariants[otherDataGroup];
    const otherSelectedVariant = document.querySelector(`[data-group="${otherDataGroup}"][variant-id].selected`);
    if (otherSelectedVariant) {
      otherSelectedVariant.classList.remove("selected");
    }
  }

}
  if (variantId && dataGroup) {
    const isAlreadySelected = this.classList.contains("selected");
    if (isAlreadySelected) {
      delete ProductBundle.selectedVariants[dataGroup];
      this.classList.remove("selected");
    } else {            
      ProductBundle.selectedVariants[dataGroup] = variantId;
      const otherVariants = document.querySelectorAll(`[data-group="${dataGroup}"][variant-id]:not([variant-id="${variantId}"])`);
      otherVariants.forEach((el) => el.classList.remove("selected"));
      this.classList.add("selected");    
    }     
    ProductBundle.addorremoveadditionalproduct();
    ProductBundle.formupdate();    
    ProductBundle.priceupdate();  
    ProductBundle.LastStepProductAppend(); 
      
  }
}
}

class BundleProduct {
  static getCartData() {
    const cartData = [];
    for (const dataGroup in ProductBundle.selectedVariants) {
      const bundleId = ProductBundle.selectedVariants[dataGroup];      
      const quantity = 1; 
      cartData.push({ bundleId, quantity });
    }
    return cartData;
  }
}

customElements.define("product-card-bundle", ProductBundle); 

const checkoutButton = document.querySelector(".bundlecheckout");
checkoutButton.addEventListener("click", (event) => {
  event.preventDefault();

  const cartData = BundleProduct.getCartData();
  let href = "/cart/"; 
  let formData = {
  'items': []
};
cartData.forEach((product, index) => {
  let productCardBundle = document.querySelector(`[variant-id="${product.bundleId}"]`);
  let item = {
    'id': product.bundleId,
    'quantity': product.quantity,
    'properties': {}
  };  
  const lengthInput = productCardBundle.querySelector('input[name="properties[length]"]');
  const lengthValue = lengthInput ? lengthInput.value : '';
  let datagroup = productCardBundle.getAttribute("data-group");    
if(datagroup == 'stainless-steel' || datagroup == 'galvanized-chain'  || datagroup == 'Rope' && lengthValue) {
  item.quantity = lengthValue;
}
  if(datagroup == 'Shackle' ) {
  item.quantity = 2;
}
  if (lengthValue) {
    //item.quantity = lengthValue;
    item.properties['length'] = lengthValue;
  }  
  formData.items.push(item);
});

fetch('/cart/clear.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  }
})
.then(response => response.json())
.then(data => {
  //alert('You cleared the cart!');
})
.catch(error => {
  console.error('An error occurred:', error);
});
setTimeout(function(){
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(response => {
  return response.json();
}).then(function(response) {
                    if (response.status) {
                      alert(response.status)
                    } else {
                     document.location.href = '/cart/checkout';
                    }
                })
.catch((error) => {
  console.error('Error:', error);
});
  }, 2000);
});  


$(document).bind('DOMNodeInserted', function(e) {
 if(e.target.className == "bcontact-success-notification"){
   setTimeout(function(){
 location.reload();
     }, 5000);
 }
});
});
const radioButtons = document.getElementsByName('chain_type');
radioButtons.forEach(radioButton => {
  radioButton.addEventListener('change', handleRadioChange);
});
function handleRadioChange(event) {
  document.querySelectorAll(`[data-group="stainless-steel"]`).forEach((el) => {
    if (el.classList.contains('selected')) {
        //el.classList.remove('selected');      
        const clickEvent = new Event('click', { bubbles: true });        
        el.dispatchEvent(clickEvent);
    }
});

    document.querySelectorAll(`[data-group="galvanized-chain"]`).forEach((el) => {    
         if (el.classList.contains('selected')) {
        //el.classList.remove('selected');      
        const clickEvent = new Event('click', { bubbles: true });        
        el.dispatchEvent(clickEvent);
    }
    });
}
